module.exports = {"header":"As a customer at Deveo, it will soon be possible to log in and manage your solution.","text":"However, we are not yet ready yet, but stay updated on our Facebook page.","button":"Return to main page","meta":{"title":"Deveo | Login","description":"As a customer at Deveo, it will soon be possible to log in and manage your solution."}}


//////////////////
// WEBPACK FOOTER
// ./src/app/login/lang/en.lang.json
// module id = 344
// module chunks = 1